export const buildQuestionPayload = ({
  text,
  userName,
  isAnonymous,
  timestamp,
}) => ({
  text,
  ...(!isAnonymous ? { name: userName || 'Anonymous' } : {}),
  timestamp,
  visible: 1,
});

export const getQuestionDisplayName = ({ name, isAnonymous }) =>
  isAnonymous ? 'Anonymous' : name || 'Anonymous';

export const shouldShowQuestionManagementControls = (features = {}) =>
  features.hasQuestionManagementControls !== false;
